import { useEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';
import { recordNavigation } from '@/lib/navHistory';

/**
 * Records every in-app navigation for "where did I come from" (lib/navHistory.ts). Rendered in the shell **before**
 * DocumentTitle, so a page's entry exists by the time its title is written.
 */
export function NavHistoryTracker() {
  const location = useLocation();
  const type = useNavigationType();
  useEffect(() => {
    recordNavigation(location.key, `${location.pathname}${location.search}`, type);
  }, [location.key]); // eslint-disable-line react-hooks/exhaustive-deps
  return null;
}
